import { QueryModel, SortModel } from '../../../utils/DataTableQueryProvider/DataTableQuery.types';
import { OnQuickReportsChanged } from '../../../utils/DataTableTypes';
import { TIME_INTERVAL_OPTIONS } from './QuickReports.constants';
import { FormCreateScheduleExport, TimeInterval } from './QuickReports.type';

export const convertBEScheduleToUDS = <Q extends QueryModel, S extends SortModel>(
  schedule: OnQuickReportsChanged<Q, S>['schedule'] | undefined
): Partial<FormCreateScheduleExport> => ({
  fileFormat: schedule?.fileFormat ?? 'CSV',
  startTimestamp: schedule?.startTimestamp ? new Date(schedule.startTimestamp as unknown as string) : undefined,
  timeInterval: schedule?.timeInterval ?? 'NEVER'
});

export const getActiveQuickReport = <Q extends QueryModel, S extends SortModel>(
  quickReports: OnQuickReportsChanged<Q, S>[] | undefined,
  activeQuickReportId?: string
): OnQuickReportsChanged<Q, S> | undefined =>
  (quickReports ?? []).find((report) => report.quickReportId === activeQuickReportId);

export const getDefaultQuickReport = <Q extends QueryModel, S extends SortModel>(
  quickReports: OnQuickReportsChanged<Q, S>[] = []
): OnQuickReportsChanged<Q, S> | undefined => quickReports.find((report) => report.default);

export const reorderQuickReports = <Q extends QueryModel, S extends SortModel>(
  list: OnQuickReportsChanged<Q, S>[],
  startIndex: number,
  endIndex: number
) => {
  const result = [...list];
  if (startIndex === endIndex) return result;
  const [removed] = result.splice(startIndex, 1);
  if (removed) {
    result.splice(endIndex, 0, removed);
  }
  return result;
};

export const filterQuickReports = <Q extends QueryModel, S extends SortModel>(
  pinned: boolean,
  quickReports: OnQuickReportsChanged<Q, S>[] = []
): OnQuickReportsChanged<Q, S>[] => quickReports.filter((report) => (pinned ? report.pinned : !report.pinned));

export const getRepeatScheduleLabel = (repeat: TimeInterval): string =>
  TIME_INTERVAL_OPTIONS?.find((option) => option.value === repeat)?.label ?? '';
